export class StoreImportBalanceModel {
    counter: number = 0;
    branchId: number = 0;
    dateBalances: Date = new Date();
    workshopCode: number = 0;
    articleCode: number = 0;
    storeCode: number = 0;
    quantity: number = 0;
    devolutionConsecutive: number = 0;
    devolutionDate: Date = new Date();
    costCenterCode: number = 0;
    constructor(counter: number,
        branchId: number,
        dateBalances: Date,
        workshopCode: number,
        articleCode: number,
        storeCode: number,
        quantity: number,
        devolutionConsecutive: number,
        devolutionDate: Date,
        costCenterCode: number) {
        this.counter = counter;
        this.branchId = branchId;
        this.dateBalances = dateBalances;
        this.workshopCode = workshopCode;
        this.articleCode = articleCode;
        this.storeCode = storeCode;
        this.quantity = quantity;
        this.devolutionConsecutive = devolutionConsecutive;
        this.devolutionDate = devolutionDate;
        this.costCenterCode = costCenterCode;
    }
}